import { Link } from 'react-router-dom';

interface FooterProps {
  onOpenForm: () => void;
}

export default function Footer({ onOpenForm }: FooterProps) {
  return (
    <footer className="bg-teal-500 text-white py-16 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          {/* Logo 與簡介 */}
          <div>
            <Link to="/" className="inline-block">
              <h3 className="text-2xl font-bold mb-4">0 元一頁式網站</h3>
            </Link>
            <p className="text-teal-50 leading-relaxed">
              專業的網站解決方案，<br />
              讓您的事業在網路上穩定發展
            </p>
          </div>

          {/* 快速連結 */}
          <div>
            <h4 className="text-lg font-semibold mb-4">快速連結</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-teal-50 hover:text-white transition-colors duration-200 cursor-pointer">
                  首頁
                </Link>
              </li>
              <li>
                <Link to="/annual-plan" className="text-teal-50 hover:text-white transition-colors duration-200 cursor-pointer">
                  年度管理方案
                </Link>
              </li>
            </ul>
          </div>

          {/* 聯絡資訊 */}
          <div>
            <h4 className="text-lg font-semibold mb-4">聯絡我們</h4>
            <ul className="space-y-3">
              <li className="flex items-center text-teal-50">
                <i className="ri-mail-line mr-3 text-xl"></i>
                <span>service@example.com</span>
              </li>
              <li>
                <Link
                  to="/consultation"
                  className="flex items-center text-teal-50 hover:text-white transition-colors duration-200 cursor-pointer group"
                >
                  <i className="ri-chat-smile-2-line mr-3 text-xl group-hover:scale-110 transition-transform duration-200"></i>
                  <div className="text-left">
                    <div className="font-medium">免費諮詢申請</div>
                    <div className="text-xs text-teal-100">填寫資料,我們將盡快與您聯繫</div>
                  </div>
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* 版權資訊 */}
        <div className="border-t border-teal-400 pt-8 text-center">
          <p className="text-teal-50 text-sm">
            © 2024 0 元一頁式網站. All rights reserved. | 
            <a 
              href="https://readdy.ai/?ref=logo" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="ml-2 hover:text-white transition-colors duration-200 cursor-pointer"
            >
              Powered by Readdy
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}
